import React from 'react'
import { CheckCircleFilled, InfoCircleOutlined } from '@ant-design/icons'

const operatorSymbols = {
  EQUAL: '=',
  NOT_EQUAL: '≠',
  GREATER_THAN: '>',
  LESS_THAN: '<',
  GREATER_THAN_OR_EQUAL: '≥',
  LESS_THAN_OR_EQUAL: '≤',
  IS_BETWEEN: 'between',
  IS_NOT_BETWEEN: 'not between',
  CONTAINS: 'contains',
  DOES_NOT_CONTAIN: 'does not contain',
  STARTS_WITH: 'starts with',
  DOES_NOT_START_WITH: 'does not start with',
  ENDS_WITH: 'ends with',
  DOES_NOT_END_WITH: 'does not end with',
  IN_THE_FOLLOWING: 'in',
  NOT_IN_THE_FOLLOWING: 'not in',
}

const toTitleCase = (str) => {
  return str
    ?.toLowerCase()
    ?.split('_')
    ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(' ')
}

const formatConditionValue = (condition) => {
  const operator = operatorSymbols[condition?.operator]
  const type = toTitleCase(condition?.type)
  
  if (!operator) {
    return {
      type,
      operator: '',
      value: `${condition?.timeOperator || ''} ${condition?.time_value || ''} ${condition?.count ? `(${condition?.count} times)` : ''}`.trim()
    }
  }
  
  if (operator === 'between' || operator === 'not between') {
    return {
      type,
      operator,
      value: `${condition?.value} - ${condition?.timeOperator || ''} ${condition?.time_value || ''}`.trim()
    }
  }
  
  if (operator === 'in' || operator === 'not in') {
    const values = Array.isArray(condition?.value) 
      ? condition.value.join(', ')
      : condition?.value || ''
    return {
      type,
      operator,
      value: values.length > 50 ? values.substring(0, 47) + '...' : values
    }
  }
  
  return {
    type,
    operator,
    value: `${condition?.value || ''} ${condition?.timeOperator || ''} ${condition?.time_value || ''} ${condition?.count ? `(${condition?.count} times)` : ''}`.trim()
  }
}

export const CheckAttributeTooltip = ({ conditions }) => {
  if (!conditions || conditions.length === 0) {
    return (
      <div className="p-2">
        <div className="text-gray-500 text-sm">No conditions defined</div>
      </div>
    )
  }

  return (
    <div className="check-attr-tooltip">
      <div className="tooltip-header">
        <InfoCircleOutlined className="mr-2" />
        <span className="font-semibold">Attribute Conditions</span>
      </div>
      <div className="tooltip-conditions">
        {conditions.map((condition, index) => {
          const formatted = formatConditionValue(condition)
          return (
            <React.Fragment key={index}>
              {index > 0 && (
                <div className="condition-connector">AND</div>
              )}
              <div className="condition-item">
                <div className="condition-row">
                  <span className="condition-type">{formatted.type}</span>
                  {formatted.operator && (
                    <span className="condition-operator">{formatted.operator}</span>
                  )}
                </div>
                {formatted.value && (
                  <div className="condition-value">{formatted.value}</div>
                )}
              </div>
            </React.Fragment>
          )
        })}
      </div>
      <div className="tooltip-footer">
        <CheckCircleFilled className="text-green-500 mr-1" />
        <span className="text-xs">Reached: 0</span>
      </div>
    </div>
  )
}

export const formatConditionsSummary = (conditions) => {
  if (!conditions || conditions.length === 0) return 'No conditions'
  
  const firstCondition = conditions[0]
  const formatted = formatConditionValue(firstCondition)
  const summary = `${formatted.type} ${formatted.operator} ${formatted.value}`.trim()
  
  if (conditions.length > 1) {
    return `${summary} (+${conditions.length - 1} more)`
  }
  
  return summary.length > 40 ? summary.substring(0, 37) + '...' : summary
}